/**
 * The promise that is returned on all calls to this function.
 */
let loadPromise: Promise<unknown> = null;

/**
 * Will queue up loading the map API, or retrieve the in-progress promise if the
 * API has already been queued.
 * @param url The full URL to the api script to load.
 */
export default function LoadMapsAPI(url: string): Promise<unknown> {
	if (!loadPromise) {
		loadPromise = new Promise((resolveLoading) => {
			new Promise((resolveMap) => {
				const mapScript = document.createElement('script');
				mapScript.type = 'text/javascript';
				mapScript.src = url;
				mapScript.onload = () => resolveMap();
				document.body.appendChild(mapScript);
			}).then(() => {
				// https://github.com/googlemaps/v3-utility-library
				const infoBoxScript = document.createElement('script');
				infoBoxScript.type = 'text/javascript';
				infoBoxScript.src = '/js/lib/infobox.js';
				infoBoxScript.onload = () => resolveLoading();
				document.body.appendChild(infoBoxScript);
			});
		});
	}
	return loadPromise;
}
